<template>
  <div class="card px-1 pt-4 p-1 mb-3">
    <div class="text-center">
      <h5><a :href="getOfficeUrl" class="textlink">{{ getOfficeTitle }}</a></h5>
      <span  class="small">
        <small>Режим работы: с {{getOfficeWorkTimeStart}} до {{getOfficeWorkTimeEnd}}</small>
      </span>
      <div class="mb-3" v-if="cUserSale != false">Ваша скидка: <span class="mb-3 sale-badge"> {{ cUserSale }}%</span></div>
      <div class="text-center small noselect">
        <span class="icon prev" @click="prevDate()" :class="{disable:!viewPrew}"></span>{{ dateFormat }}<span
          @click="nextDate()" class="icon next"></span>
        <div>{{ dateFormatDay }}</div>
      </div>
    </div>
    <div class="booking-table my-4">

      <template v-if="this.$store.state.vMode == 1">
        <div :class="[getXClass, {vMode2: this.$store.state.vMode == 2}]">
          <div class="cabcard-wrap">
            <template v-for="(cabId) in getCabinetsSortData" v-bind:key="cabId">
              <CabCardMobile
                  v-bind:cab-id="Number(cabId)"
                  v-bind:office-id="Number(officeId)"
              />
            </template>
          </div>
          <div class="wrapper-scroll cell-wrap">
            <template v-for="(cabId) in getCabinetsSortData" v-bind:key="cabId">
              <div ref="targetRefScrollStart" class="table-content ">
                <TimeLineMobile v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"/>
                <BTWallCellsMobile
                    v-bind:cab-id="Number(cabId)"
                    v-bind:cab-data="getCabinetsPrices[cabId]"
                    v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"
                />
              </div>
            </template>
          </div>
        </div>
      </template>
      <template v-if="this.$store.state.vMode == 2">
        <div :class="[getXClass, {vMode2: this.$store.state.vMode == 2}]">

            <template v-for="(cabId) in getCabinetsSortData" v-bind:key="cabId">
              <CabCardMobile
                  v-bind:cab-id="Number(cabId)"
                  v-bind:office-id="Number(officeId)"
              />
              <BTWallCellsMobile
                  v-bind:cab-id="Number(cabId)"
                  v-bind:cab-data="getCabinetsPrices[cabId]"
                  v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"
              />
            </template>

        </div>
      </template>
      <template v-if="this.$store.state.vMode == 0 && this.$store.state.x == 1">
        <div class="cardline">
          <div class="cabinet-top-wrapper">
            <div class="cabinet-top no"></div>
          </div>

        <template v-for="(cabId) in getCabinetsSortData" v-bind:key="cabId">
            <CabCardMobile
                v-bind:cab-id="Number(cabId)"
                v-bind:office-id="Number(officeId)"
            />
        </template>
        </div>
        <div class="old-view" :class="[{vMode0: this.$store.state.vMode == 0},getXClass]">
          <div class="wall-cells vertical">
            <TimeLineMobile v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"/>
          </div>
          <template v-for="(cabId) in getCabinetsSortData" v-bind:key="cabId">
                <BTWallCellsMobile
                    v-bind:cab-id="Number(cabId)"
                    v-bind:cab-data="getCabinetsPrices[cabId]"
                    v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"
                />
          </template>
        </div>
      </template>
      <template v-if="this.$store.state.vMode == 0 && this.$store.state.x > 1">

        <div class="sticky" :class="[getXClass]">
          <div class="wrapper-scroll sync-scroll-cabinet">
          <div class="vertical-cells-wrap">
            <div class="cabinet-top-wrapper first">

            </div>
            <template v-for="(cabId) in getCabinetsSortData" v-bind:key="cabId">
              <CabCardMobile
                  v-bind:cab-id="Number(cabId)"
                  v-bind:office-id="Number(officeId)"
              />
            </template>
          </div>
        </div>
        </div>
        <div class="old-view" :class="[{vMode0: this.$store.state.vMode == 0},getXClass]">

          <div class="vertical-timeline">
            <TimeLineMobile v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"/>
          </div>
          <div class="wrapper-scroll size-container sync-scroll-pills">

            <div class="vertical-cells-wrap">
            <template v-for="(cabId) in getCabinetsSortData" v-bind:key="cabId">
              <BTWallCellsMobile
                  v-bind:cab-id="Number(cabId)"
                  v-bind:cab-data="getCabinetsPrices[cabId]"
                  v-bind:startTime="getOfficeWorkTimeStart" v-bind:endTime="getOfficeWorkTimeEnd"
              />
            </template>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>

</template>

<script>
import BTWallCellsMobile from "@/components/BookingTableMobile/BTWallCellsMobile";
import CabCardMobile from "@/components/BookingTableMobile/CabCardMobile";
import {dateFormat} from "@/dateFormat";
import TimeLineMobile from "@/components/BookingTableMobile/TimeLineMobile";


export default {
  components: {
    CabCardMobile,
    BTWallCellsMobile,
    TimeLineMobile
  },
  props: {
    officeId: Number
  },
  provide() {
    // use function syntax so that we can access `this`
    return {
      officeId: Number(this.officeId),
      selectData: this.getSelectData,
      mySelectData: this.getMySelectData,
      errorData: this.getErorrData
    }
  },
  name: 'BookingTableMobile',
  data() {
    return {
      daysTitle: [
        'воскресенье',
        'понедельник',
        'вторник',
        'среда',
        'четверг',
        'пятница',
        'суббота'
      ],
      viewPrew: false,
    }
  },
  mounted() {


    this.scrollToWorkPill()
    this.scrollInit()
    // brick.scrollTo({ behavior: 'smooth' });
    // подписываемся на события wall cell, когда надо перепроверить все правила
    this.$emitter.off('revalidate_'+ this.officeId)
    this.$emitter.on('revalidate_'+ this.officeId, () => {
      // console.log('Надо обновить все ячейки в officeId' + this.officeId)
      // создаем событие для кабинетов, на проверить правила
      this.$emitter.emit('revalidate_walls_'+ this.officeId)
    })
    // создаем событие для автоматического выбора ячеек
    this.$emitter.off('autoselect_'+ this.officeId)
    this.$emitter.on('autoselect_'+ this.officeId, (data) => {
      for (var key of Object.keys(data)) {
        this.$emitter.emit('autoselect_pill_'+ data[key], data[key])
      }
    })
  },
  created() {
    if ([0,1,2].indexOf(this.$store.state.vMode ) == -1 ){
      this.$store.dispatch('setVMode', 0);
    }
    // this.$refs.targetRefScrollStart.scrollTo({ behavior: 'smooth' });
  },
  updated() {

    this.scrollToWorkPill()
    this.scrollInit()
  },
  watch: {
    '$store.state.date'(val) {
      let nowDate = dateFormat.formatDate(dateFormat.getDateNowWithTimeZone())
      if (dateFormat.compare(val, nowDate) == '>') {
        // console.log('ALEX','VIEW')
        this.viewPrew = true
      } else {
        // console.log('ALEX','NOW')
        this.viewPrew = false
      }

    }
  },
  computed: {
    cUserSale: function () {
      if(this.cIsUser){
        if(this.officeId in this.$store.state.user.userSales){
          return  Number(this.$store.state.user.userSales[this.officeId])
        }else{
          return Number(this.$store.state.user.userSale);
        }
      }
      return false;
    },
    cIsUser: function () {
      return this.$store.state.user !== false ? true : false;
    },
    getXClass() {
      return 'xsize-' + this.$store.state.x;
    },
    dateFormat() {
      return dateFormat.strToFormat(this.$store.state.date)
    },
    dateFormatDay() {
      let date = new Date(this.$store.state.date)
      let dayNum = date.getDay()
      return this.daysTitle[dayNum]
    },
    getCalcKey() {
      return this.calcKey;
    },
    getErorrData() {
      return this.$store.state.selector.error
    },
    getSelectData() {
      return this.$store.state.selector.new
    },
    getMySelectData() {
      return this.$store.state.selector.my
    },
    getOfficeTitle() {
      return this.$store.state.office.data[this.officeId]['title']
    },
    getOfficeUrl() {
      return '/places/' + this.$store.state.office.data[this.officeId]['url_alias']
    },
    getOfficeWorkTimeStart(){
      return this.$store.state.office.data[this.officeId]['workTimeStart']
    },
    getOfficeWorkTimeEnd(){
      return this.$store.state.office.data[this.officeId]['workTimeEnd']
    },
    getCabinetsPrices() {
      // console.log(this.$store.state.cabinet.data.cabinetsPrices[this.officeId])

      return this.$store.state.cabinet.data.cabinetsPrices[this.officeId]
    },
    getCabinetsSortData() {
      return this.$store.state.cabinet.data.cabinetsSortData[this.officeId]
    },
  },
  methods: {
    scroll_t1(e){
      let parent = e.currentTarget.closest('.booking-table');
      if (parent) {
        let syncscroll = parent.querySelector('.wrapper-scroll.sync-scroll-pills');
        syncscroll.scrollLeft = e.currentTarget.scrollLeft
      }
    },
    scroll_t2(e){
      let parent = e.currentTarget.closest('.booking-table');
      if (parent) {
        let syncscroll = parent.querySelector('.wrapper-scroll.sync-scroll-cabinet');
        syncscroll.scrollLeft = e.currentTarget.scrollLeft
      }
    },
    scrollInit() {
      //синхронизация скроллинга линии кабинетов и броней
      if (this.$store.state.vMode == 0 && this.$store.state.x > 1){
        let tableAll = document.querySelectorAll('.booking-table');
        for (let table of tableAll){

          var syncScrollCabinet = table.querySelector('.wrapper-scroll.sync-scroll-cabinet');
          var syncScrollPills = table.querySelector('.wrapper-scroll.sync-scroll-pills');

          syncScrollCabinet.removeEventListener("scroll", this.scroll_t1);
          syncScrollCabinet.addEventListener('scroll', this.scroll_t1);
          syncScrollPills.removeEventListener("scroll", this.scroll_t2);
          syncScrollPills.addEventListener('scroll', this.scroll_t2);
        }
      }
    },

    scrollToWorkPill(){
      // скролим до ячейки, которая еще актуальна (время не истекло)
      if (this.$store.state.vMode == 1 && this.$refs.targetRefScrollStart.length) {
        let brick = this.$refs.targetRefScrollStart[0].querySelectorAll('.outdate');
        if (brick.length) {
          let outBlockCell = brick[brick.length - 1].closest('.cell');
          let offstLeft = outBlockCell.offsetLeft;
          let offstWidth = outBlockCell.offsetWidth;
          let wrapperScrl = outBlockCell.closest('.wrapper-scroll');
          wrapperScrl.scrollLeft = offstLeft + offstWidth;
        }else{
          let wrapperScrl = this.$refs.targetRefScrollStart[0].closest('.wrapper-scroll');
          wrapperScrl.scrollLeft = 0;
        }
      }
    },
    prevDate() {
      this.$emitter.emit('prevDate')
    },
    nextDate() {
      this.$emitter.emit('nextDate')
    },
  }
}
</script>
<style>
.vertical-timeline{
  display: flex;
  flex-direction: column;
  container-name: vertical-timeline-cnt;
  container-type: inline-size;
  margin-right: 1px;
}

.size-container{
  display: block;
  width: 100%;
  container-name: size-container-cnt;
  container-type: inline-size;
}

.xsize-2 .vertical-timeline{
  /*width: calc(100% / 8);*/
  /*min-width:calc(100% / 8);*/
  width: 50px;
  min-width:50px;
}
.xsize-3 .vertical-timeline{
  /*width: calc(100% / 6);*/
  /*min-width:calc(100% / 6);*/

  width: 60px;
  min-width:60px;
}
.vertical-cells-wrap{
  display: flex;
  flex-direction: row;

  /*width: fit-content;*/

}


.cabinet-top-wrapper{
  width: 100%;
  container-name: cabinet-top-wrapper-cnt;
  container-type: inline-size;
  margin-bottom: 1px;
  margin-right: 1px;
  background: #fff;
}
.xsize-3 .vertical-cells-wrap .cabinet-top-wrapper.first{
  width: 60px!important;
  min-width: 60px!important;
}
.xsize-2 .vertical-cells-wrap .cabinet-top-wrapper.first{
  width: 50px!important;
  min-width: 50px!important;
}



.cabinet-top{
  display: flex;
  width: 100%;
  background: #fff8da;
  /*border-radius: 5px;*/
  align-items: center;
  justify-content: center;
  flex-direction: column;
  container-name: cabinet-top-cnt;
  container-type: inline-size;
}

.cabinet-top-txt{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  padding-left: .5em;
  padding-right: .5em;
}
.xsize-2 .vertical-cells-wrap .cabinet-top-wrapper {
  width: 100%!important;
  /*min-width: 15cqw!important;*/
  min-width: 50px !important;
}

.xsize-3 .vertical-cells-wrap .cabinet-top-wrapper {
  width: 100%!important;
  /*min-width: 19cqw!important;*/
  min-width: 60px !important;

}

.cabinet-top.no{
  background: none;
  margin-right: 0px;
}
.sticky{
  position: sticky;
  top: 0px;
  width: 100%;
  z-index: 2000;
}
.cardline{
  display: flex;
  width: 100%;
  position: sticky;
  top: 0px;
  z-index: 999;
  background: #fff;
}
@container cabinet-top-wrapper-cnt (max-width: 100px) {
  .cabinet-top{
    height: 100cqw!important;
    border-radius: 5px;
  }
  .cabinet-top{
    font-size:  .5em;
    font-size:  18cqw;
  }
}
</style>
<style scoped>
.old-view{
  display: flex;
  flex-direction: row;

}

.cabcard-wrap {
  position: absolute;
  top: 0;
  left: 0;
}
.vMode2 .cabcard-wrap {
  position: relative;
}
.cell-wrap {
  margin-top: 4rem;
}

.xsize-1 .table-content {
  margin-bottom: 6rem;
}

.xsize-2 .table-content {
  margin-bottom: 6rem;
}

.xsize-3 .table-content {
  margin-bottom: 7rem;
}

.table-content:last-child {
  margin-bottom: 0rem !important;
}

.noselect {
  user-select: none;
}

.disable {
  opacity: .1;
}

.icon {
  position: relative;
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  background-repeat: no-repeat;
  background-position: bottom;
  position: relative;
  top: 6px;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color ease .4s;
}

.icon:hover {
  background: #ffdec0;
}

.icon.next {

  margin-left: .5rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23e07a5f' class='bi bi-arrow-right-circle' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z'/%3E%3C/svg%3E");
}

.icon.prev {
  margin-right: .5rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23e07a5f' class='bi bi-arrow-left-circle' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z'/%3E%3C/svg%3E");
}

.booking-table {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  will-change: transform;
}

/*.cab-info-wrap {*/
/*  min-width: 250px;*/
/*}*/
.wrapper-scroll {
  overflow: hidden;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.wrapper-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.wrapper-scroll .scroll-y {
  display: none !important;
}


.relblock-wrap {
  position: relative;
}

.relblock {
  /*max-width: 250px;*/
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}


.relblock-wrap {
  background-color: #fff;
  transition: background-color ease .7s;
}

.relblock-wrap.loading {
  background-color: #faf9f9;
}

/*.relblock {*/
/*  opacity: 1;*/
/*  transition: opacity ease .7s;*/
/*}*/

/*.relblock-wrap.loading .relblock {*/
/*  opacity: 0;*/
/*}*/

.textlink {
  color: #444;
  text-decoration: none;
}

</style>